var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hbp-container hbp-container-above" }, [
    _c("div", { staticClass: "homepage router-view" }, [
      _c("div", { staticClass: "post-list" }, [_c("Banner")], 1),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "latest-announcement" }, [
        _c("h3", { staticClass: "homepage__floor-title" }, [
          _vm._v("最新公告")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "homepage__floor-tip" }, [
          _vm._v("提供最新的活动，请及时查看和关注")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "announcements" }, [
          _c(
            "ul",
            { staticClass: "announcement-list-homepage" },
            _vm._l(_vm.latestData, function(it) {
              return _c(
                "li",
                { key: it.title, staticClass: "homepage__card-item--three" },
                [
                  _c("div", { staticClass: "homepage__card-title--three" }, [
                    _vm._v(_vm._s(it.title))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "homepage__card-content--three" }, [
                    _vm._v(_vm._s(it.description))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "homepage__card-time--three" }, [
                    _vm._v(_vm._s(it.creationDateStr))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              path: "/announcement/detail",
                              query: { code: it.announcementId }
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass:
                              "iconfont icon-youjiantou homepage__card-arrow--right"
                          })
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "announcement-list-more" },
          [
            _c(
              "router-link",
              {
                staticClass: "homepage__floor-button homepage__floor-button",
                attrs: { to: "announcement" }
              },
              [_c("span", [_vm._v("查看更多")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "about-me" }, [
        _c("h3", { staticClass: "homepage__floor-title" }, [
          _vm._v("关于我们")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "homepage__floor-tip" }, [
          _vm._v("让您快速了解我们的工作以及我们能为您带来的服务")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "about-me-content" }, [
          _vm._v(
            "\n        荣耀一直致力于保护广大用户的安全，荣耀安全应急响应中心(Honor Security Response Center)非常欢迎广大用户向我们反馈荣耀产品和业务的安全漏洞，以帮助我们提升产品和业务的安全性。\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "about-me-submit" },
          [
            _c(
              "router-link",
              {
                staticClass:
                  "homepage__floor-button homepage__floor-button--near",
                attrs: { to: "report" }
              },
              [_c("span", [_vm._v(" 提交漏洞")])]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rection-flow" }, [
      _c("h3", { staticClass: "homepage__floor-title" }, [_vm._v("响应流程")]),
      _vm._v(" "),
      _c("div", { staticClass: "homepage__floor-tip" }, [
        _vm._v(
          "我们会有专业的人员对您提交的报告进行评估，跟进并及时反馈最新的处理结果"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "rection-flow-img" }, [
        _c("img", { attrs: { src: require("../../images/home_flow.png") } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dd2e005", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd2e005","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/Home.vue
// module id = null
// module chunks = 